import { cn } from '@/lib/utils'

export function Skeleton({ className }: { className?: string }) {
	return <div className={cn('animate-pulse rounded-md bg-neutral-200/70', className)} aria-hidden="true" />
}
